module.exports = __webpack_public_path__ + "static/media/header-mpv.88adfc03.png";